export default {
    ADMIN: 'Admin',
    APPROVER: 'Approver',
    HOLDER: 'TripHolder',
    BOOKER: 'Booker',
    FINANCE_MANAGER: 'FinanceManager',
    STANDARD_USER: 'StandardUser',
};



// WEBPACK FOOTER //
// ./src/app/constants/user-roles.js